import { combineReducers } from '@reduxjs/toolkit'
import user from './user.store'
import password from './password.store'
import verifyAccess from './verify-access.store'
import phone from './phone.store'
import owners from './owners.store'

export const rootReducer = combineReducers({
  user,
  password,
  verifyAccess,
  phone,
  owners,
})
